import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionId } from 'vopay';
import useFetchCurrencyConversionTransaction from '@/hooks/useApi/useFetchCurrencyConversionTransaction';
import CurrencyConversionTransactionInfo from './CurrencyConversionTransactionInfo';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type CurrencyConversionTransactionContainerProps = TransactionId & { jwt: string };

export default function CurrencyConversionTransactionContainer({
  TransactionID,
  jwt,
}: CurrencyConversionTransactionContainerProps) {
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { currencyConversionTransaction, fetchCurrencyConversionTransaction } = useFetchCurrencyConversionTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    blockingLoader.show();

    fetchCurrencyConversionTransaction({ TransactionID })
      .catch((error) => {
        // Not returned: the dialog's promise settles on dismissal, and the loader must drop before that.
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred'));
      })
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  const transaction = currencyConversionTransaction?.Transactions;

  return <div>{transaction && <CurrencyConversionTransactionInfo transaction={transaction} />}</div>;
}
